import React from 'react';
import {
  Box,
  Typography,
  Chip
} from '@mui/material';
import {
  WorkOutline as JobIcon,
  QuestionAnswer as InterviewIcon,
  Description as ResumeIcon,
  People as CandidateIcon,
  Email as EmailIcon,
  Assessment as AssessmentIcon
} from '@mui/icons-material';

const QuickActions = ({ onQuickAction, isLoading }) => {
  const quickActions = [
    {
      id: 'job-description',
      label: 'Job Description',
      icon: <JobIcon />,
      description: 'Generate job descriptions'
    },
    {
      id: 'interview-questions',
      label: 'Interview Questions',
      icon: <InterviewIcon />,
      description: 'Get interview questions'
    },
    {
      id: 'resume-tips',
      label: 'Resume Tips',
      icon: <ResumeIcon />,
      description: 'Resume review tips'
    },
    {
      id: 'candidate-screening',
      label: 'Candidate Screening',
      icon: <CandidateIcon />,
      description: 'Screening guidelines'
    },
    {
      id: 'email-templates',
      label: 'Email Templates',
      icon: <EmailIcon />,
      description: 'Candidate emails'
    },
    {
      id: 'assessment-tips',
      label: 'Assessment Tips',
      icon: <AssessmentIcon />,
      description: 'Evaluation criteria'
    }
  ];

  return (
    <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
      <Typography variant="subtitle2" gutterBottom color="text.secondary">
        Quick Actions:
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {quickActions.map((action) => (
          <Chip
            key={action.id}
            icon={action.icon}
            label={action.label}
            onClick={() => onQuickAction(action.id)}
            variant="outlined"
            size="small"
            clickable
            disabled={isLoading}
            title={action.description}
            sx={{
              '&:hover': {
                bgcolor: '#1a237e',
                color: 'white',
                '& .MuiChip-icon': {
                  color: 'white'
                }
              },
              transition: 'all 0.2s ease'
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default QuickActions;
